// 테스트용 가상 경기 결과 (.../:category/test 숨김 URL에서만 사용)
// 선수 100명, 2위는 실제 DB 최장 이름(46자, 2025년 SGP 선수)과 같은 길이의 가상 이름

const PLAYER_COUNT = 100;

// 둘 다 46자
const LONGEST_NAMES = {
  M: "Muhammad Aqil Hafizudin Bin Mohamad Zulkarnain",
  F: "Nurul Aisyah Farhana Binte Mohamad Zulkarnaini",
};

const FIRST_NAMES = {
  M: [
    "Minjun", "Seojun", "Doyun", "Arman", "Batbayar", "Emre", "Kenji",
    "Rahul", "Daniyar", "Farid", "Tuan", "Lucas", "Mateo", "Aziz",
    "Haruto", "Bilal", "Omar", "Timur", "Nikolai", "Ravi",
  ],
  F: [
    "Seoyeon", "Jiwoo", "Hana", "Aigerim", "Oyuna", "Elif", "Yuki",
    "Priya", "Aruzhan", "Leila", "Linh", "Sofia", "Camila", "Aisha",
    "Sakura", "Zeynep", "Mariam", "Dinara", "Anna", "Meera",
  ],
};
const LAST_NAMES = [
  "Kim", "Lee", "Park", "Choi", "Tanaka", "Yilmaz", "Sharma",
  "Bekova", "Nguyen", "Erdene", "Rahman", "Silva", "Ivanova", "Kaya",
  "Sato", "Hassan", "Petrova", "Singh", "Garcia", "Ali",
];
const COUNTRIES = [
  "KOR", "MYS", "SGP", "KGZ", "IND", "MNG", "TUR",
  "JPN", "KAZ", "VNM", "TRNC", "USA", "FRA", "IRN",
];

// 1위 25점, 2위 24점(단독), 3위부터 23점 → 1점까지 내려가며 동점자 포함
const getTotal = (index) => {
  if (index === 0) return 25;
  if (index === 1) return 24;
  return 23 - Math.floor(((index - 2) * 23) / (PLAYER_COUNT - 2));
};

// 총점을 회차(0~5점) 5개로 나눔, 남는 점수는 선수마다 다른 회차에 배분
const splitScores = (total, index) => {
  const base = Math.floor(total / 5);
  const scores = Array(5).fill(base);
  for (let i = 0; i < total % 5; i++) {
    scores[(index + i) % 5] += 1;
  }
  return scores;
};

// API score-list 응답의 score_array 와 같은 형태
const createMockScoreArray = (gender) =>
  Array.from({ length: PLAYER_COUNT }, (_, index) => ({
    player_number: 101 + ((index * 37) % PLAYER_COUNT),
    country: COUNTRIES[index % COUNTRIES.length],
    player_name:
      index === 1
        ? LONGEST_NAMES[gender]
        : `${FIRST_NAMES[gender][index % FIRST_NAMES[gender].length]} ${
            LAST_NAMES[(index * 7) % LAST_NAMES.length]
          }`,
    gender: gender,
    turn_concat: "1,2,3,4,5",
    score_concat: splitScores(getTotal(index), index).join(","),
  }));

// 렌더마다 새 배열이 생기면 MatchResultsView 의 useEffect 가 반복 실행되므로 미리 생성
export const MOCK_SCORE_ARRAYS = {
  m: createMockScoreArray("M"),
  f: createMockScoreArray("F"),
};
